import React, {useState} from 'react';
import {globalExerciseTypeCoolDown, globalExerciseTypeWarmUp} from "../shared/Constants";

function ExerciseQuickSearchResultCell({exercise, setSelectedExercise, exerciseIndex, showHeader, exerciseMap}) {
    const [showPreview, setShowPreview] = useState(false);

    function onExerciseSelected(){
        setSelectedExercise(exercise);
    }

    function showVideoPreview(event){
        event.stopPropagation();
        setShowPreview(true);
    }

    function hideVideoPreview(event){
        event.stopPropagation();
        setShowPreview(false);
    }

    function getRightSubText(){
        return (
            <div className="quickExerciseSearchRightSubText">
                {(exercise["PREMIUM"] === "TRUE") && <div className="premiumText">PREMIUM</div>}
                {(exercise["TYPE"] === globalExerciseTypeWarmUp) && <div className="warmUpText">WARM UP</div>}
                {(exercise["TYPE"] === globalExerciseTypeCoolDown) && <div className="coolDownText">COOL DOWN</div>}
            </div>
        )
    }

    function getExerciseCellRightDiv(){
        return (
            <>
                <div className={"quickExerciseSearchExerciseCellRightDiv"}>
                    <div className="flexGrowOne exerciseNameDescDiv">
                        <div className="quickSearchExerciseName">{exercise["NAME"]}</div>
                        <div className="muscleGroupEquipment">
                            {/*{cleanString(exerciseMap.get(exercise["ID"])["MUSCLE_GROUP"])} | {cleanString(exercise["EQUIPMENT"])} {exercise["EXTRA_EQUIPMENT"] && "| " + cleanString(exercise["EXTRA_EQUIPMENT"])}*/}
                            {exerciseMap.get(exercise["ID"])["MUSCLE_GROUP_NAMES"].join(", ")} | {exercise["EQUIPMENT_NAMES"].join(", ")} {exercise["EXTRA_EQUIPMENT_NAMES"]?.length > 0 ? "| " + exercise["EXTRA_EQUIPMENT_NAMES"].join(", ") : ""}
                        </div>
                        {getRightSubText()}
                    </div>
                    {/*{getRightSubText()}*/}
                </div>
            </>
        )
    }

    function getExerciseLeftDiv(){
        return (
            <div className="quickExerciseSearchExerciseCellLeftDiv">
                <img className="quickSearchExerciseImage"
                     src= {exercise.THUMB_URL}
                     loading="lazy"
                     alt={exercise["NAME"] + " exercise thumbnail"}/>
            </div>
        )
    }

    function getVideoPreviewButton(){
        if (!exercise["VIDEO_URL"]){
            return null;
        }

        return (
            <button type="button" className="exercise-preview-button quick-exercise-preview-button" onClick={showVideoPreview} title="Preview exercise video" aria-label="Preview exercise video">
                ▶
            </button>
        )
    }

    function getVideoPreviewModal(){
        if (!showPreview){
            return null;
        }

        return (
            <div className="modal exercise-preview-modal" style={{display: "flex"}} onClick={hideVideoPreview}>
                <div className="modal-content-centered exercise-preview-modal-content" onClick={(event) => event.stopPropagation()}>
                    <video className="exercise-preview-video" src={exercise["VIDEO_URL"]} autoPlay loop muted playsInline controls />
                </div>
            </div>
        )
    }

    function getSectionHeaderTitle(){
        const exerciseType = exercise["TYPE"];

        if (exerciseType === globalExerciseTypeWarmUp){
            return "Dynamic Warm Up Stretching";
        } else if (exerciseType === globalExerciseTypeCoolDown ){
            return "Static Cool Down Stretching";
        } else {
            return exercise["MUSCLE_GROUP"];
        }
    }

    return (
        <>
            {showHeader && exerciseIndex === 0 &&
                <div className={"quick-exercise-header exercise-search-cell-header"}>{getSectionHeaderTitle()}</div>
            }

            <div className={"exercise-search-cell-div"} onClick={onExerciseSelected}>
                {getVideoPreviewButton()}
                <div className="exercise-cell">
                    {getExerciseLeftDiv()}
                    {getExerciseCellRightDiv()}
                </div>
                <div className="exercise-separater"></div>
            </div>
            {getVideoPreviewModal()}
        </>
    );
}

export default ExerciseQuickSearchResultCell;
